import Cookies from "js-cookie";
const TokenKey: string = "app_auth";
const UserKey: string = "user_id";
const UserKey_id: string = "userLoggedIn_id";

export function getToken(): string | undefined {
  return Cookies.get(TokenKey);
}
export function setToken(token: string): string | undefined {
  return Cookies.set(TokenKey, token);
}
export function getId(): string | undefined {
  return Cookies.get(UserKey);
}
export function setId(id: string): string | undefined {
  return Cookies.set(UserKey, id);
}
export function setUserId(id: string): string | undefined {
  return Cookies.set(UserKey_id, id);
}

export function getUserId(): string | undefined {
  return Cookies.get(UserKey_id);
}
export function clearAllCookie() {
  Cookies.remove(TokenKey);
  Cookies.remove(UserKey);
  Cookies.remove(UserKey_id);
}
